module.exports = __webpack_public_path__ + "assets/img/img327.87ab3852.png";